module.exports = __webpack_public_path__ + "img/people-sitting-inside-a-restaurant-3252051.107f37b0.jpg";